import checkFile from './checkFile';

export default function handleFileUpload(event, format, handler) {
  const file = event.target.files[0];
  if (!checkFile(file, format)) return;
  handler(file);
}
